import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button/Button';
export const PageButton = ({ page, active, onClick }) => {
    const text = (page + 1).toString();
    const color = active ? 'action' : 'grey';
    const variant = active ? 'dark' : 'light';
    return (_jsx(Button, { color: color, variant: variant, textFont: 'monospace', onClick: onClick, children: text }));
};
